import { EtabFamilyModel, IEtabCategory, IEtabFamily } from "@core/models";

export const etabFamilySelectedIdMocks = 1;

export const etabFamiliesMocks = [
  {
    [IEtabFamily.id]: etabFamilySelectedIdMocks,
    [IEtabFamily.code]: "CAFE_REST",
    [IEtabFamily.label]: "Caf\u00e9s / Restaurants",
    [IEtabFamily.categories]: [
      {
        [IEtabCategory.id]: 50,
        [IEtabCategory.code]: "REST_PLAGE",
        [IEtabCategory.label]: "Restaurant de Plage",
        [IEtabCategory.segment]: "CHR",
      },
      {
        [IEtabCategory.id]: 2,
        [IEtabCategory.code]: "BRASS_CHIC",
        [IEtabCategory.label]: "Brasserie Chic",
        [IEtabCategory.favorite]: 1,
        [IEtabCategory.segment]: "CHR",
      },
      {
        [IEtabCategory.id]: 15,
        [IEtabCategory.code]: "REST_WORLD",
        [IEtabCategory.label]: "Restaurant World food",
        [IEtabCategory.segment]: "CHR",
      },
    ],
  },
  {
    [IEtabFamily.id]: 2,
    [IEtabFamily.code]: "BAR_CLUB",
    [IEtabFamily.label]: "Bars / Clubs",
  },
  {
    [IEtabFamily.id]: 3,
    [IEtabFamily.code]: "HOTEL",
    [IEtabFamily.label]: "H\u00f4tel",
  },
].map((family) => new EtabFamilyModel(family));
